import { Component, OnInit } from '@angular/core';
import { CartService } from '../commons/cart.service';
import { ConfigService } from '../commons/config.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppComponent } from '../app.component';

declare var _gaq: any;
declare var ga: any;
declare var fbq: Function;

@Component({

  selector: 'campionario-completed',
  template: require('./campionario-completed.component.html'),

})
export class CampionarioCompletedComponent implements OnInit {

  constructor(
    public cartService: CartService,
    public config: ConfigService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {

  }

  ngOnInit() {

    $('#loaderApp').hide();

    let idTransaction = 0;
    this.activatedRoute.params.subscribe((params: Params) => {
      idTransaction = params['idTransaction'] as number;
    });

    if (idTransaction !== 0) {

      // FACEBOOK ECOMMERCE
      fbq('track', 'Purchase', {
        content_ids: 99,
        content_type: 'product',
        value: this.config.campionarioPrice,
        currency: 'EUR'
      });


      // ANALYTICS ECOMMERCE
      ga('require', 'ecommerce', 'ecommerce.js');
      ga('ecommerce:addTransaction', {
        'id': idTransaction,
        'affiliation': 'Topcolor - Campionario',
        'revenue': this.config.campionarioPrice,
        'shipping': 0,
        'tax': this.config.campionarioPrice - (this.config.campionarioPrice / 1.22)
      });
      ga('ecommerce:send');


      ////console.log('ACQUISTO CAMPIONARIO COMPLETATO');

      //this.sendAdWordsConversion();


    }

  }

  // sendAdWordsConversion(){
  //   window.dataLayer = window.dataLayer || [];
  //     function gtag(){dataLayer.push(arguments);}
  //     gtag('js', new Date());

  //     gtag('config', 'AW-851653320');
  //     //console.log('conversione adwords AW-851653320');
  //   </script>

  //   <!-- Event snippet for Ordine Completato conversion page -->
  //   <script>
  //     gtag('event', 'conversion', {
  //         'send_to': 'AW-851653320/tDADCN6TxHEQyOWMlgM',
  //         'value': 1.0,
  //         'currency': 'EUR'
  //     });
  //     //console.log('conversione adwords AW-851653320');
  // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/campionario-completed.component.ts